export const clearRecoveredFormAfterSuccessfulSave = async (
    saveRequest: Promise<unknown>,
    storageKey: string,
): Promise<void> => {
    try {
        await saveRequest;
        if (storageKey) sessionStorage.removeItem(storageKey);
    } catch {
        // Keep the recovery copy when the save fails.
    }
};
